<template>
  <div v-if="product?.eyebrow">
    <vf-toggletip
      v-if="product.eyebrow.details"
      placement="bottom-end"
      :props-trigger="{ class: 'flex gap-1 items-center' }"
    >
      <template #trigger>
        <p v-bind="eyebrowStyle" class="line-clamp-1 eyebrow">
          {{ product.eyebrow.label }}
        </p>
        <vf-icon name="info" />
      </template>
      {{ product.eyebrow.details }}
    </vf-toggletip>
    <p
      v-else-if="product.eyebrow.label"
      v-bind="eyebrowStyle"
      class="line-clamp-1 eyebrow"
    >
      {{ product.eyebrow.label }}
    </p>
  </div>
</template>

<script lang="ts" setup>
const { eyebrowStyle, product } = usePdp()
</script>
